<template>
  <div>
    <van-nav-bar placeholder title="意见提交" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
      </template>
    </van-nav-bar>

    <van-form @submit="onSubmit">
      <van-field
              readonly
              clickable
              name="ideaTypeName"
              :value="form.ideaTypeName"
              label="意见类型"
              placeholder="请选择"
              class="select"
              @click="showPicker = true"
              :rules="[{ required: true, message: '意见类型不能为空' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker value-key="label" show-toolbar :columns="ideaTypeOptions" @confirm="onConfirm"
                    @cancel="showPicker = false"/>
      </van-popup>
      <van-field
              v-model="form.ideaDes"
              name="ideaDes"
              rows="2"
              autosize
              label="说明"
              class="sm"
              type="textarea"
              maxlength="255"
              placeholder="请输入"
              show-word-limit
              :rules="[{ required: true, message: '说明不能为空' }]"
      />
      <van-field name="ideaUrls" label="图片">
        <template #input>
          <custom-upload ref="upload" :value="form.ideaUrls"/>
        </template>
      </van-field>
        <van-button :loading="formLoading" round block type="info" native-type="submit" class="floatbox">提交</van-button>

    </van-form>
  </div>
</template>

<script>
  import {save} from '@/api/my/idea'
  import {getDictByType} from '@/api/common'
  import customUpload from '@/components/customUpload'

  export default {
    name: 'ideaAdd',
    components: {
      // eslint-disable-next-line vue/no-unused-components
      customUpload
    },
    data() {
      return {
        form: {
          ideaDes: ''
        },
        formLoading: false,
        ideaTypeOptions: [],
        showPicker: false
      }
    },
    computed: {},
    created() {
      this.getDict()
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      getDict() {
        // 查询字典，意见类型
        getDictByType('idea_type').then(res => {
          if (res.code === 10000) {
            this.ideaTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      onConfirm(data) {
        this.form.ideaType = data.value
        this.form.ideaTypeName = data.label
        this.showPicker = false
      },
      onSubmit() {
        this.formLoading = true
        this.form.ideaUrls = this.$refs.upload.getFileList().join(',')
        save(this.form).then(res => {
          if (res.code === 10000) {
            this.$toast(res.msg)
            this.$router.go(-1)
          }
        }).finally(() => {
          this.formLoading = false
        })
      }
    }
  }
</script>

<style scoped>
/deep/.van-cell{
  padding:10px  15px;
}
/deep/.van-field__label{
  width:80px;
  font-size:14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
  box-sizing: border-box;
}
/deep/.select .van-field__value {
  height:35px;
  background: #F4F5F7;
  border-radius:100px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
/deep/.sm .van-field__value {
  height: 95px;
  background: #F4F5F7;
  border-radius:6px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  flex-direction: column;
}
/deep/.van-field__body{
  display: flex;
  width: 100%;
}
/deep/.sm .van-field__body{
  min-height:65px;
  align-items: flex-start;
  padding-top:5px;
  overflow-y: auto;
}
/deep/.van-field__word-limit{
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
/deep/.van-field__control{
  display: flex;
}
/deep/.van-cell::after{
  display: none;
}
/deep/.van-uploader__upload{
  width:116px;
  height:74px;
}
/deep/.van-uploader__preview-image{
  width:116px;
  height:74px;
}
</style>
